
  
// SEARCH POSITION SWITCH //  
  
function resize() {
    if ($(window).width() < 1024) {
      $('.nav-search').addClass('nav-search-section').removeClass('nav-search');
    }
    else {
      $('.nav-search-section').addClass('nav-search').removeClass('nav-search-section');
         }
    if ($(window).width() > 1024) {
      $('.mobile-search').addClass('browser-search').removeClass('mobile-search');
    }
    else {
      $('.browser-search').addClass('mobile-search').removeClass('browser-search');
         }
}

$(document).ready( function() {
    $(window).resize(resize);
    resize();
});



 // MOBILE SIDEBAR SWITCH //  
   
        function show() {
        $('#sidebar').toggleClass( "active" );
        $('body').scrollTop(400);
        $('#move-out').toggleClass( "active" );
        $('.mobile-nav').toggleClass( "active" );
        $('.menu-announcement-container').toggleClass( "active" );
        $('#move-search').removeClass( "active" );
        $('.mobile-search').removeClass( "active" );
        $('.mobile-suggestions').removeClass( "active" );
      } 
    
    
        function search() {
        $('body').scrollTop(400);
        $('#move-search').toggleClass( "active" );
        $('.mobile-search').toggleClass( "active" );
        $('.mobile-suggestions').toggleClass( "active" );
        $('.menu-announcement-container').toggle();
      }     


    



// BOOTSTRAP CAROUSEL SWIPE // 

$(".carousel").swipe({

  swipe: function(event, direction, distance, duration, fingerCount, fingerData) {

    if (direction == 'left') $(this).carousel('next');
    if (direction == 'right') $(this).carousel('prev');

  },
  allowPageScroll:"vertical"

});



// Listen for cart updates
document.addEventListener('cart:update', function(event) {
    // Retrieve cart data from the event
    var cartData = event.detail;

    // Iterate through line items in the cart
    cartData.items.forEach(function(item) {
        // Check if the item matches any bundle tag
        Object.keys(bundles).forEach(function(tag) {
            var bundle = bundles[tag];
            if (item.tags.includes(tag) && bundle_tag_counts[tag] < bundle.quantity) {
                var quantity_to_include = Math.min(item.quantity, bundle.quantity - bundle_tag_counts[tag]);
                bundle_tag_counts[tag] += quantity_to_include;
                // Calculate updated price
                var updatedPrice = (bundle.price * quantity_to_include) / bundle.quantity;
                // Update line item price in the cart
                // Use Shopify's Cart API to update the line item price
                // This step depends on your store's specific implementation
            }
        });
    });
});

// Example function to update the cart
function updateCartWithNewPrices(newPrices) {
    // Use Shopify's Cart API to update the cart with new prices
    // This step depends on your store's specific implementation
}

    